import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  OnInit,
  signal,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { AccountMarketplace, CustomCampaignNameTokens } from "@front/m19-api-client";
import { AccountMarketplaceService } from "@front/m19-services";
import {
  IButtonDirective,
  IFormFieldComponent,
  IInputDirective,
  ILabelComponent,
  IToggleComponent,
  MODAL_DATA,
  ModalRef,
  ToasterService,
} from "@front/m19-ui";
import { TranslocoDirective } from "@jsverse/transloco";
import { CustomCampaignNameHighlightPipe } from "@m19-board/settings/account-settings/account-group/custom-campaign-name-pop-up/custom-campaign-name-highlight-pipe";

@Component({
  templateUrl: "./update-custom-campaign-name.component.html",
  encapsulation: ViewEncapsulation.None,
  imports: [
    TranslocoDirective,
    CustomCampaignNameHighlightPipe,
    IButtonDirective,
    FormsModule,
    IInputDirective,
    ILabelComponent,
    IFormFieldComponent,
    IToggleComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpdateCustomCampaignNameComponent implements OnInit {
  private accountMarketplaceService = inject(AccountMarketplaceService);
  private toasterService = inject(ToasterService);

  modalData = inject(MODAL_DATA) as UpdateCustomCampaignNameModalData;
  modalRef = inject(ModalRef);

  customCampaignName?: string;
  customCampaignNameHighlighted?: string;
  CustomCampaignNameTokens = Object.values(CustomCampaignNameTokens);
  edit!: boolean;

  canEdit = signal(this.modalData.accountMarketplace.customCampaignName !== null);

  @ViewChild("customCampaignNameElement") inputElement!: ElementRef;

  ngOnInit() {
    this.customCampaignName = this.modalData.accountMarketplace.customCampaignName;
    this.customCampaignNameHighlighted = this.modalData.accountMarketplace.customCampaignName;
  }

  renderCustomCampaignName() {
    this.customCampaignNameHighlighted = this.customCampaignName;
    this.edit = false;
  }

  setEditCustomCampaignName() {
    this.edit = true;
    setTimeout(() => this.inputElement?.nativeElement?.focus(), 10);
  }

  addTokenToInput(token: string): void {
    this.customCampaignName = this.customCampaignName ? this.customCampaignName + token : token;
    this.renderCustomCampaignName();
  }

  validPattern() {
    return !this.canEdit || (this.customCampaignName && this.customCampaignName.trim());
  }

  update() {
    const newCustomCampaignName = this.canEdit() ? this.customCampaignName : "m19 default pattern";
    this.accountMarketplaceService
      .changeCustomCampaignName(this.modalData.accountMarketplace, newCustomCampaignName ?? "")
      .subscribe({
        next: () => {
          this.toasterService.success(
            "Custom Campaign Name successfully changed to " +
              newCustomCampaignName +
              " on " +
              this.modalData.accountMarketplace.accountName +
              ".",
            "Custom campaign name updated",
          );
        },
        error: (error) => this.toasterService.error(error, "Custom campaign name update error"),
      });
    this.modalRef.close();
  }
}

export interface UpdateCustomCampaignNameModalData {
  accountMarketplace: AccountMarketplace;
}
